import { getDaysLeftInTrial, sendTrackingEvent, showMessage } from "h-commons";
import { useSelector } from "react-redux";
import { trialFeaturesSelector } from "./redux/selector";
import { addonLabels, contact_us_event, getFeatureKey } from "./constants";

export function getAddon(addonKey) {
    const trialFeaturesData = useSelector(trialFeaturesSelector);
    return trialFeaturesData && trialFeaturesData.find(ele => ele.addon_key === addonKey);
}

export const isDeltaFeatureOnTrial = (featureKey, deltaFeatures) => {
    if (Array.isArray(featureKey)) {
        return featureKey.some(feature => deltaFeatures.includes(feature));
    } 
    return deltaFeatures.includes(featureKey);
}

export function getAddonId(addonKey) {
    const addon = getAddon(addonKey);
    return addon && addon.plan_addon_id;
}

export function onContactUs(feature,smId) {
    showMessage({
        message: "Thank you! We will get in touch shortly",
        type: "success"
    });
    sendTrackingEvent(contact_us_event,{
        'Feature name': feature,
        'SM ID':smId
    });
}

export function getTrialData(trialFeatures, deltaFeatures, routes) {
    const newRoutes = routes.map((ele) => ({ ...ele }));
    for (const route of newRoutes) {
        const addonKey = addonLabels[route.label];
        const featureKey = getFeatureKey(route.label)
        const addon = trialFeatures && trialFeatures.find(ele => ele.addon_key === addonKey);
        const exploringHigherPlanAddOn = featureKey && isDeltaFeatureOnTrial(featureKey, deltaFeatures)
        route.isPurchased = addon && (addon.start_date && !(addon.trial_state) && !(addon.end_date));
        route.isTrial = Boolean(addon);
        route.trialState = addon && addon.trial_state;
        route.isExploringHigherPlan = exploringHigherPlanAddOn
    }
    return newRoutes;
}

export const remainingDaysUiText = (remainingDays) => {
    if (remainingDays > 0) {
        const pluralSuffix = remainingDays === 1 ? '' : 's';
        return `in ${remainingDays} day${pluralSuffix}.`;
    } else {
        return 'today.';
    }
}


export function getRemainingDays(addonKey) {
    const addon = getAddon(addonKey);
    const endDate = addon && addon.end_date;
    const remainingDays = getDaysLeftInTrial(endDate);
    const remainingDaysText = remainingDaysUiText(remainingDays);
    return remainingDaysText;
}

export function checkTrialState(addonKey) {
    const addon = getAddon(addonKey);
    return addon && addon.trial_state === 'active';
}